// Generated from SVG to Code Figma Plugin

import { forwardRef } from 'react';

export const BaseFillIntelligentDuration = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    variant?: 'currentColor' | 'blueToWhite';
  }
>(({ variant = 'currentColor', ...props }, ref) => (
  <svg ref={ref} width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    {variant === 'blueToWhite' && (
      <defs>
        <linearGradient id="gradient-intelligent-duration" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#8A9FFF" />
          <stop offset="100%" stopColor="#FFFFFF" />
        </linearGradient>
      </defs>
    )}
    <path
      d="M11.2759 5.06897C11.3955 4.23158 12.6045 4.23158 12.7241 5.06897C13.1839 8.28736 15.7126 10.8161 18.931 11.2759C19.7684 11.3955 19.7684 12.6045 18.931 12.7241C15.7126 13.1839 13.1839 15.7126 12.7241 18.931C12.6045 19.7684 11.3955 19.7684 11.2759 18.931C10.8161 15.7126 8.28736 13.1839 5.06897 12.7241C4.23158 12.6045 4.23158 11.3955 5.06897 11.2759C8.28736 10.8161 10.8161 8.28736 11.2759 5.06897Z"
      fill={variant === 'currentColor' ? 'currentColor' : 'url(#gradient-intelligent-duration)'}
    />
  </svg>
));

BaseFillIntelligentDuration.displayName = 'BaseFillIntelligentDuration';
